export default __webpack_public_path__ + "static/media/problem-1-30-min.db58bf7f.png";